import { Component, Inject, OnInit, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-fc-popup',
  standalone: true,
  imports: [],
  templateUrl: './fc-popup.component.html',
  styleUrl: './fc-popup.component.scss',
})
export class FcPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<FcPopupComponent>
  ) {}

  fcdetails: any[] = this.data.fcData;
  familyCode: string = this.data.fc;
  ngOnInit() {
    console.log(this.data, this.fcdetails, 'fc details');
  }
  onCrossClick() {
    this.dialogRef.close();
  }
}
